import React from "react";
import { Settings } from "lucide-react";
import ScheduleDemoBlock from "./ScheduleDemoBlock";
import { ActiveDemoCard, ResolvedDemoRow } from "./DemoCards";
import { CONFIG_OUTCOMES } from "../demos/demoConstants";

// Bloque de la llamada de configuración (llamada 2, tras la venta): agenda, gestiona la
// activa y enseña el historial. Vive junto al bloque de demo en la ficha del lead, pero
// se rige por su propio origen ("config") y su propio pipeline de resultados.
// El ojo de vista previa vive DENTRO de ScheduleDemoBlock (kind="config"): solo ahí se
// conoce el closer/fecha/hora que el admin está eligiendo de verdad.
export default function ConfigCallBlock({ lead, activeConfig, resolvedConfigs, onChanged, simulated }) {
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 text-sky-700 font-black text-xs uppercase tracking-wider pt-1">
        <Settings size={16} /> Llamada de configuración
      </div>

      {activeConfig && (
        <ActiveDemoCard
          demo={activeConfig}
          onApplied={onChanged}
          simulated={simulated}
          outcomes={CONFIG_OUTCOMES}
          scheduledLabel="Configuración agendada"
        />
      )}

      {!activeConfig && (
        <ScheduleDemoBlock lead={lead} onScheduled={onChanged} kind="config" simulated={simulated} />
      )}

      {resolvedConfigs.length > 0 && (
        <div className="space-y-1.5">
          <div className="text-[11px] font-bold uppercase text-gray-400">Historial de configuración</div>
          {resolvedConfigs.map((d) => <ResolvedDemoRow key={d.demo_id} demo={d} />)}
        </div>
      )}
    </div>
  );
}
